module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "role": "presentation",
      "viewBox": "0 0 16 16",
      "width": _vm.width,
      "height": _vm.height,
      "aria-labelledby": _vm.iconName
    }
  }, [_c('title', {
    attrs: {
      "id": _vm.iconName,
      "lang": "en"
    }
  }, [_vm._v(_vm._s(_vm.iconName))]), _c('g', {
    attrs: {
      "fill": _vm.iconColor
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36cd3031","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svgicon/Svgbase.vue
// module id = 850155793f190885581d
// module chunks = 6